import React, { useEffect, useRef, useState } from "react";
import { Facebook } from "lucide-react";

/**
 * Widget Page Plugin Facebook officiel — chargé en iframe (pas besoin du SDK JS).
 * S'adapte à la largeur réelle du conteneur grâce à un ResizeObserver
 * (sinon Facebook coupe le contenu à droite sur mobile).
 */
export const FacebookEmbed = ({
  url,
  tabs = "timeline",
  height = 700,
  showCover = true,
  showFacepile = true,
  small = false,
}) => {
  const ref = useRef(null);
  const [w, setW] = useState(340);

  useEffect(() => {
    if (!ref.current) return;
    const update = () => {
      if (!ref.current) return;
      const px = ref.current.getBoundingClientRect().width;
      // FB Page Plugin accepte 180–500 ; on borne et on arrondit.
      const clamped = Math.max(180, Math.min(500, Math.floor(px)));
      setW(clamped);
    };
    update();
    const ro = new ResizeObserver(update);
    ro.observe(ref.current);
    window.addEventListener("orientationchange", update);
    return () => { ro.disconnect(); window.removeEventListener("orientationchange", update); };
  }, []);

  if (!url) return null;
  const params = new URLSearchParams({
    href: url,
    tabs: small ? "" : tabs,
    width: String(w),
    height: String(height),
    small_header: small ? "true" : "false",
    adapt_container_width: "true",
    hide_cover: showCover ? "false" : "true",
    show_facepile: showFacepile ? "true" : "false",
    locale: "fr_FR",
  });
  const src = `https://www.facebook.com/plugins/page.php?${params.toString()}`;
  return (
    <div ref={ref} className="facebook-embed w-full">
      <iframe
        src={src}
        title="Page Facebook ARNAK"
        width={w}
        height={height}
        style={{ border: "none", overflow: "hidden", width: "100%", maxWidth: "100%", display: "block" }}
        scrolling="no"
        frameBorder="0"
        allowFullScreen
        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
      />
    </div>
  );
};

/**
 * Mini bouton "J'aime" + lien direct vers la page Facebook.
 * Plus léger qu'un iframe, n'oblige pas Facebook à charger.
 */
export const FacebookLikeButton = ({ url, label = "Suivre sur Facebook" }) => {
  if (!url) return null;
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      className="inline-flex items-center gap-2 px-4 py-2.5 bg-[#1877F2] hover:bg-[#0e6ae0] text-white font-bold text-sm rounded-full shadow-lg transition"
      data-testid="facebook-like-btn"
    >
      <Facebook size={16} fill="currentColor" /> {label}
    </a>
  );
};

export default FacebookEmbed;
